module.exports = __webpack_public_path__ + "img/vector_certo_cortado.56ab895c.jpg";